<template lang="pug">
  div
    | Write &times; AI / User Interface Experiment / v1.99 /
    |
    vs-button(transparent size='large' href='https://tmat.me').button-link Artyom
    |
    | made this.
</template>

<script>
export default {
  name: 'Header'
}
</script>

<style scoped lang="less">
.section {
  display: inline-block;
  margin-right: 2em;
}

.version {
  font-weight: 600;
  font-style: italic;
}

.button-link {
  display: inline-block;
  margin: -10px -15px;
  font-weight: 600;
  font-style: italic;
}
</style>